import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type SearchTitleComponentProps = {
    query: string;
};

const SearchTitleComponent = ({ query }: SearchTitleComponentProps) => {
    const { t } = useGranite();

    return (
        <h1 className="heading-1">
            {t("search.results.title")}{" "}
            {query !== "" && (
                <span className={"font-weight-bold"}>
                    &laquo;{query}&raquo;
                </span>
            )}
        </h1>
    );
};

export { SearchTitleComponent };
